import { useQuery } from 'react-query'
import { axios } from 'lib'
import { toast } from 'react-toastify'

export interface LoadProductRawMaterialsAsProductsQuery {
  // priceTableId?: string
  search?: string
}

export interface RawMaterialAsProduct {
  [key: string]: any
}

type Response = {
  data: RawMaterialAsProduct[]
}

const loadProductRawMaterialsAsProducts = (
  query: LoadProductRawMaterialsAsProductsQuery
): Promise<Response> => {
  return axios.get(`/orders/products/raw-materials`, {
    params: query
  })
}

export function useLoadProductRawMaterialsAsProducts(
  query: LoadProductRawMaterialsAsProductsQuery,
  enabled = true
) {
  return useQuery(
    ['productRawMaterialsAsProducts', query],
    () => loadProductRawMaterialsAsProducts(query),
    {
      enabled: enabled,
      onError: () =>
        toast.error(
          'Não foi possível carregar as matérias primas como produtos!',
          {
            toastId: 'loadProductRawMaterialsAsProducts'
          }
        )
    }
  )
}
